var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul class=\"reaction-users\"></ul>\n<div class=\"infinite-css-spinner-wrapper\">\n  <div class=\"infinite-css-spinner\"></div>\n</div>\n";
},"useData":true});